(function () {
  'use strict';

  angular
    .module('directive.mini-cart', [])

    .directive('miniCart', function () {
      return {
        restrict: 'E',
        /* @ngInject */
        controller: ["$scope", "$element", "AppService", "RoutesService", "ModalService", function ($scope, $element, AppService, RoutesService, ModalService) {
          var ctrl = this;

          // Translate
          var tplTranslate = {};
          $element.children('.translate').children().each(function () {
            var $this = $(this);
            tplTranslate[$this.attr('key')] = $this.html();
          });

          getCart();

          ctrl.emptyCart = function () {
            ModalService.show(
              '/Template/Cart/ModalClearCartConfirm',
              {},
              null,
              'clearCartConfirmModalCtrl'
            );
          };

          ctrl.remove = function (line) {
            ModalService.show(
              '/Template/Cart/ModalDeleteConfirm',
              {
                action: function () {
                  AppService.deleteLine(line.IDLine, line.Product.Designation, line.Product.IDPicture, tplTranslate.titleDeleteOk);
                }
              },
              null,
              'deleteConfirmModalCtrl'
            );
          };

          $scope.$on('cartUpdate', function () {
            getCart();
          });

          function getCart() {
            AppService.getParams()
              .then(function (params) {
                ctrl.hasCart = params.HasCart && (params.Cart && params.Cart.Products && params.Cart.Products.length);
                ctrl.cartLink = !ctrl.hasCart ? '' : '/' + RoutesService.getUrlByName('Cart');
                ctrl.showTTCPrice = params.Visitor.CardType.ShowTTCPrice;
                ctrl.count = 0;
                if (ctrl.hasCart) {
                  ctrl.data = params.Cart;
                  var count = 0;
                  _.each(ctrl.data.Products, function (line) {
                    count += line.Quantity;
                  });
                  ctrl.count = count;
                }
              })
              .catch(function (error) {
                console.error(error);
              });
          }
        }],
        controllerAs: 'miniCartCtrl'
      };
    })

    /* @ngInject */
    .controller('deleteConfirmModalCtrl', ["data", "device", "options", "ModalService", function (data, device, options, ModalService) {
      var ctrl = this;

      ctrl.submit = function () {
        ModalService.close();
        data.action();
      };
      ctrl.cancel = function () {
        ModalService.close();
        if (data.cancel) data.cancel();
      };

    }])

    /* @ngInject */
    .controller('clearCartConfirmModalCtrl', ["data", "$rootScope", "HttpService", "AppService", "ModalService", "toastr", function (data, $rootScope, HttpService, AppService, ModalService, toastr) {
      var ctrl = this;

      ctrl.submit = function () {
        ModalService.close();
        $rootScope.$broadcast('showPageLoader', true);
        HttpService.post({
          url: 'Cart/ClearCart',
          data: {}
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                AppService.updateParams(response.results);
                toastr.success('', translate.messages.ClearCartOK, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
                if (data.action) data.action();
              } else {
                toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              $rootScope.$broadcast('showPageLoader', false);
            })
            .catch(function (error) {
              console.error(error);
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };
    }]);

})();
